
export default {
	computed: {
		isSingleColumnErrorLayout() {
			const statusCode = this.$store.state.error.statusCode;
			if (statusCode === 500) {
				return false;
			}

			return true;
		},
	},
};
